import React from 'react';

import Message from 'components/Message';

import SmartRateFaqLinkMessage from '../SmartRateFaqLinkMessage';
import { SMART_RATE_FAQ_IDS } from '../SmartRateFaqs.constants';
import MaximizesRevenueDemandIllustration from './MaximizesRevenueDemandIllustration';
import messages from './MaximizesRevenuePanel.messages';
import SmartRateTopicPanelLayout from './SmartRateTopicPanelLayout';

const MaximizesRevenuePanel = () => (
  <SmartRateTopicPanelLayout
    summaryBody={
      <>
        <Message as="p" message={messages.summaryBodyParagraph1} />
        <SmartRateFaqLinkMessage
          as="p"
          faqId={SMART_RATE_FAQ_IDS.CREDIT_LEVELS}
          message={messages.summaryBodyParagraph2WithLink}
          messageWithoutLink={messages.summaryBodyParagraph2}
        />
      </>
    }
    summaryHeading={messages.summaryHeading}>
    <MaximizesRevenueDemandIllustration />
  </SmartRateTopicPanelLayout>
);

export default MaximizesRevenuePanel;
